import { ColumnDef } from '@tanstack/react-table';
import { BrandAndProduct } from '@toggle/toggle';
import { TFunction } from 'i18next';
import React from 'react';

import { TopRankIcon } from '~/widgets/knowledge-graph-widget/components/top-rank-icon/TopRankIcon';
import styles from '../BrandsAndProductsTable.module.scss';

export const RANK_COLUMN_ID = 'rank';
const PRODUCT_BRAND_COLUMN_ID = 'productBrand';
const DESCRIPTION_COLUMN_ID = 'description';

export const getColumns = ({
  t,
}: {
  t: TFunction;
}): ColumnDef<BrandAndProduct>[] => [
  {
    id: RANK_COLUMN_ID,
    header: t('widget:assetOverview.knowledgeGraph.brandsAndProducts.rank'),
    cell: props => {
      const { original } = props.row;
      return (
        <div className={styles.rankWrapper}>
          <TopRankIcon rank={original.relationship.rank} />
        </div>
      );
    },
  },
  {
    id: PRODUCT_BRAND_COLUMN_ID,
    header: t(
      'widget:assetOverview.knowledgeGraph.brandsAndProducts.productBrand'
    ),
    cell: props => (
      <div className={styles.productWrapper}>{props.row.original.product}</div>
    ),
  },
  {
    id: DESCRIPTION_COLUMN_ID,
    header: t(
      'widget:assetOverview.knowledgeGraph.brandsAndProducts.description'
    ),
    cell: props => {
      return (
        <div className={styles.descriptionWrapper}>
          {props.row.original.relationship.description}
        </div>
      );
    },
  },
];
